// extracted by mini-css-extract-plugin
module.exports = {"SmallNotificationModal":"_2PwN5D1Cr5OMhBHqJPFLpo","SmallNotificationModalIcon":"an2ZohejWJwL5RfCUNK7v","SmallNotificationModalText":"_2f7t0paS7JRcVEgVrAH6it"};